import { useCallback } from "react";
import { GRID, RIGHT_PADDING_PERCENT } from "features/chart";

export const useRightPadding = (initialVisible: number) => {
  const getRightPaddingInCandles = useCallback(
    (containerWidth: number) => {
      const chartWidth = containerWidth - GRID.left - GRID.right;
      // Рассчитываем ширину одной свечи при текущем initialVisible
      const candleWidth = chartWidth / initialVisible;
      // Сколько свечей нужно для отступа RIGHT_PADDING_PERCENT
      return Math.ceil((chartWidth * RIGHT_PADDING_PERCENT) / candleWidth);
    },
    [initialVisible],
  );

  return { getRightPaddingInCandles };
};
